/* eslint-disable */
// AWS Amplify v6 configuration

function getAWSConfig () {
  const env = process.env.REACT_APP_ENV_VAR || 'local';

  if (process.env.REACT_APP_ENV_VAR === 'prod') {
    console.log = function () {};
  }

  console.log('');
  console.log('');
  console.log('Environment : ', env);

  // Default config (dev/local)
  let config = {
    Auth: {
      Cognito: {
        userPoolId: 'us-east-1_Sqn7k8Uuz',
        userPoolClientId: '2taqhb35gqbldsr2fhecptoq81',
        identityPoolId: 'us-east-1:6c43834b-f940-4047-a0a1-d63438d1f81a',
        loginWith: {
          oauth: {
            domain: 'ecal-test-alpha.auth.us-east-1.amazoncognito.com',
            scopes: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: ['http://localhost:3000/home/'],
            redirectSignOut: ['http://localhost:3000/login'],
            responseType: 'code',
          },
          username: true,
          email: true,
        },
        signUpVerificationMethod: 'code',
        userAttributes: {
          email: {
            required: true,
          },
        },
        allowGuestAccess: false,
      },
    },
  };

  if (env === 'stage') {
    console.log('using the staged build');
    config.Auth.Cognito.userPoolId = 'us-east-1_TY4n2l3nk';
    config.Auth.Cognito.userPoolClientId = '3gglpebb4ivg8ufathkk1g13pi';
    config.Auth.Cognito.identityPoolId = 'us-east-1:1260b2ec-e736-4f2e-9e0c-7f4580bfda13';
    config.Auth.Cognito.loginWith.oauth.domain = 'ecal-stage-auth.auth.us-east-1.amazoncognito.com';
  } else if (env === 'prod') {
    console.log('using the production build');
    config.Auth.Cognito.userPoolId = 'us-east-1_e9QegoXLi';
    config.Auth.Cognito.userPoolClientId = '2de7rns40b0g1baa38cc1r8cdi';
    config.Auth.Cognito.identityPoolId = 'us-east-1:4e151d4c-a81f-465a-ab00-4c2fb296034b';
    config.Auth.Cognito.loginWith.oauth.domain = 'ecal-prod-auth.auth.us-east-1.amazoncognito.com';
  }

  return config;
}

const awsmobile = getAWSConfig();

export default awsmobile;


export const redirect = {

    local: {
        signin: 'https://localhost:3000/home/',
        signout: 'https://localhost:3000/login',
        baseDomain: 'localhost:3000',
    },

    dev: {
        signin: 'https://test-app.ecal.com/home/',
        signout: 'https://test-app.ecal.com/login',
        baseDomain: 'test-app.ecal.com',
    },

    stage:  {
        signin: 'https://stage-app.ecal.com/home/',
        signout: 'https://stage-app.ecal.com/login',
        baseDomain: 'stage-app.ecal.com',
    },

    prod: {
        signin: 'https://app.ecal.com/home/',
        signout: 'https://app.ecal.com/login',
        baseDomain: 'app.ecal.com',
    },
}